import { render, staticRenderFns } from "./ModalTindakan.vue?vue&type=template&id=46ae8612&lang=pug&"
import script from "./ModalTindakan.vue?vue&type=script&lang=js&"
export * from "./ModalTindakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports